import { GET_ALL_PROPERTY_FIELD} from "./actions";

const initialState = {
  propertyField: {
    docs: [],
    totalDocs: 0,
    limit: 10,
    page: 1,
    totalPages: 0,
    pagingCounter: 0,
    hasPrevPage: false,
    hasNextPage: false,
    prevPage: null,
    nextPage: null,
  },
  propertyData: {},
  loading: true,
};

const propertyFieldReducer = (state = initialState, { type, payload }) => {

    switch(type){
        case GET_ALL_PROPERTY_FIELD:
            return {
                ...state,
                loading:false,
                propertyField:payload,
            };
        default:
            return state;

        }
}

export default propertyFieldReducer;